<template>
  <div>
    <Loading
      v-if="loadingDialogGlobal"
      :dialogProps="loadingDialogGlobal"
      :messageDialogeProps="messageGlobal"
      :loadingProps="loadingGlobalValue"
      :errorProps="errorGlobalValue"
      @closeDialog="loadingDialogGlobal = $event"
    />
    <v-card class="body">
      <!-- Excel Export Dialog -->
      <excel-export-dialog
        v-model="dialogSheetFilter"
        :sellers="items.nom"
        :suppliers="items.fournisseur"
        :date-range="[dateFormulaire[0], dateFormulaire[dateFormulaire.length - 1]]"
        @loading="val => loadingDialogGlobal = val"
        @error="handleExcelError"
      />
      
      <!-- Table Filters -->
      <div class="tableFilters d-flex flex-row align-items-center ml-lg-6 ml-2">
        <input
          class="form-control search-input mt-4"
          type="text"
          v-model="search"
          placeholder="Rechercher..."
          @input="filterResult({ type: 'search', key: search })"
          style="width: 300px"
        />
        <v-btn color="primary" class="ml-lg-4 mt-4 text-white" @click="resetFilter">
          réinitialiser les filtres
        </v-btn>
        <v-btn
          class="mt-4 ml-4 white--text"
          :color="$colors && $colors[0] ? $colors[0] : 'primary'"
          @click="dialogSheetFilter = true"
        >
          <span>excel</span>
          <v-icon dense class="ml-2">mdi-file-excel-outline</v-icon>
        </v-btn>
      </div>
      
      <!-- Data Table -->
      <table
        id="table"
        class="ma-lg-5 ma-2 table table-striped table-bordered"
        style="display: block; width: 98%; min-height: 300px; overflow-x: auto"
      >
        <!-- Table Header -->
        <thead style="background-color: #07a4ca; color: white">
          <tr class="header">
            <th
              style="text-align: left; max-height: 50px"
              v-for="column in columns"
              :key="column.name"
              :class="getColumnClass(column.name)"
            >
              <filter-dropdown 
                :label="column.label"
                :field-name="column.name"
                :filterable="column.filter"
                :sortable="column.sortable"
                :filter-items="items[column.name] || []"
                :show="activeFilter === column.name"
                @update:show="val => activeFilter = val ? column.name : ''"
                @sort="sortBy(column.name)"
                @filter-click="activeFilter = column.name"
                @filter-update="handleFilterUpdate"
                @date-filter="handleDateFilter"
              />
            </th>
          </tr>
        </thead>
        
        <!-- Table Body -->
        <tbody v-if="projects.length > 0 && !loadingTable">
          <tr v-for="(project, index) in projects" :key="project.id">
            <!-- Date -->
            <td class="td">
              <editable-field
                field-type="date"
                :initial-value="project.date"
                :project-id="project.id"
                @save-value="modifierValue"
              >
                <template v-slot:displayValue>
                  {{ project.date }}
                </template>
                <template v-slot:editField="{ updateValue }">
                  <input
                    type="date"
                    :value="formatDateForInput(project.date)"
                    @input="updateValue($event.target.value)"
                    class="form-control form-control-sm"
                  />
                </template>
              </editable-field>
            </td>
            
            <!-- Commercial (Vendeur) -->
            <td class="td">
              <div class="td-table">
                {{ project.Commercial }}
              </div>
            </td>
            
            <!-- Raison Sociale -->
            <td class="td">
              <v-tooltip v-if="project.Raison && project.Raison.length >= 15" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <small class="td-table" v-bind="attrs" v-on="on">
                    <router-link
                      :to="{
                        path: '/les-profils-societes',
                        query: { id: project.idSociete },
                      }"
                    >
                      {{ project.Raison.substring(0, 20) + "..." }}
                    </router-link>
                  </small>
                  <small>{{ project.siret }}</small>
                </template>
                <span>{{ project.Raison }}</span>
              </v-tooltip>
              <small class="td-table" v-else>
                <router-link
                  :to="{
                    path: '/les-profils-societes',
                    query: { id: project.idSociete },
                  }"
                >
                  {{ project.Raison }}
                </router-link>
              </small>
              <small>{{ project.Site }}</small>
            </td>
            
            <!-- Fournisseur -->
            <td class="td">
              <small class="td-table">
                {{ project.fournisseur }}
              </small>
            </td>
            
            <!-- Type (Energie) -->
            <td class="td">
              <div class="td-table">
                {{ project.type }}
              </div>
            </td>
            
            <!-- PDL (numCompteur) -->
            <td class="td">
              <div class="td-table">
                {{ project.numCompteur }}
              </div>
            </td>
            
            <!-- Consommation -->
            <td class="td">
              <editable-field
                field-type="consommation"
                :initial-value="project.consommation"
                :project-id="project.id"
                @save-value="modifierValue"
              >
                <template v-slot:displayValue>
                  {{ formatNumber(project.consommation) }} Mwh
                </template>
                <template v-slot:editField="{ updateValue }">
                  <input
                    type="text"
                    :value="project.consommation"
                    @input="updateValue($event.target.value)"
                    class="form-control form-control-sm"
                    placeholder="CAR"
                  />
                </template>
                <template v-slot:calculationMode>
                  <v-radio-group
                    v-model="calculationMode"
                    row
                    label="Influence sur le valeur Brut"
                  >
                    <v-radio label="Oui" value="oui"></v-radio>
                    <v-radio label="Non" value="non"></v-radio>
                  </v-radio-group>
                </template>
              </editable-field>
            </td>
            
            <!-- DDF -->
            <td class="td">
              <div class="td-table">
                {{ project.dateDF }}
              </div>
            </td>
            
            <!-- DFF -->
            <td class="td">
              <div class="td-table">
                {{ project.dateFF }}
              </div>
            </td>
            
            <!-- Marge -->
            <td class="td">
              <editable-field
                field-type="valuemarge"
                :initial-value="project.marge"
                :project-id="project.id"
                @save-value="modifierValue"
              >
                <template v-slot:displayValue>
                  {{ formatNumber(project.marge) }} €/Mwh
                </template>
                <template v-slot:editField="{ updateValue }">
                  <input
                    type="text"
                    :value="project.marge"
                    @input="updateValue($event.target.value)"
                    class="form-control form-control-sm"
                    placeholder="Marge"
                  />
                </template>
                <template v-slot:calculationMode>
                  <v-radio-group
                    v-model="calculationMode"
                    row
                    label="Influence sur les valeurs:"
                  >
                    <v-radio label="Oui" value="oui"></v-radio>
                    <v-radio label="Non" value="non"></v-radio>
                  </v-radio-group>
                </template>
              </editable-field>
            </td>
            
            <!-- Valeur Brut -->
            <td class="td">
              <editable-field
                field-type="valeurBrut"
                :initial-value="project.valeurBrut"
                :project-id="project.id"
                @save-value="modifierValue"
              >
                <template v-slot:displayValue>
                  {{ formatNumber(project.valeurBrut) }} €
                </template>
                <template v-slot:editField="{ updateValue }">
                  <input
                    type="text"
                    :value="project.valeurBrut"
                    @input="updateValue($event.target.value)"
                    class="form-control form-control-sm"
                    placeholder="Valeur Brut"
                  />
                </template>
                <template v-slot:calculationMode>
                  <v-radio-group
                    v-model="calculationMode"
                    row
                    label="Influence sur le valeur AA:"
                  >
                    <v-radio label="Oui" value="oui"></v-radio>
                    <v-radio label="Non" value="non"></v-radio>
                  </v-radio-group>
                </template>
              </editable-field>
            </td>
            
            <!-- Pourcentage -->
            <td class="td">
              <editable-field
                field-type="pourcentage"
                :initial-value="project.pourcentage"
                :project-id="project.id"
                @save-value="modifierValue"
              >
                <template v-slot:displayValue>
                  {{ project.pourcentage }} %
                </template>
                <template v-slot:editField="{ updateValue }">
                  <input
                    type="number"
                    :value="project.pourcentage"
                    @input="updateValue($event.target.value)"
                    class="form-control form-control-sm"
                    max="100"
                    min="0"
                    placeholder="Pourcentage"
                  />
                </template>
                <template v-slot:calculationMode>
                  <v-radio-group
                    v-model="calculationMode"
                    row
                    label="Influence sur le valeur AA:"
                  >
                    <v-radio label="Oui" value="oui"></v-radio>
                    <v-radio label="Non" value="non"></v-radio>
                  </v-radio-group>
                </template>
              </editable-field>
            </td>
            
            <!-- Valeur AA -->
            <td class="td">
              <editable-field
                field-type="value"
                :initial-value="project.valeur"
                :project-id="project.id"
                @save-value="modifierValue"
              >
                <template v-slot:displayValue>
                  {{ formatNumber(project.valeur) }} €
                </template>
                <template v-slot:editField="{ updateValue }">
                  <input
                    type="text"
                    :value="project.valeur"
                    @input="updateValue($event.target.value)"
                    class="form-control form-control-sm"
                    placeholder="Valeur AA"
                  />
                </template>
              </editable-field>
            </td>
            
            <!-- Valeur We Energy -->
            <td class="td">
              <editable-field
                field-type="valueGEMC"
                :initial-value="project.valeurGemc"
                :project-id="project.id"
                @save-value="modifierValue"
              >
                <template v-slot:displayValue>
                  {{ formatNumber(project.valeurGemc) }} €
                </template>
                <template v-slot:editField="{ updateValue }">
                  <input
                    type="text"
                    :value="project.valeurGemc"
                    @input="updateValue($event.target.value)"
                    class="form-control form-control-sm"
                    placeholder="Valeur We Energy"
                  />
                </template>
              </editable-field>
            </td>
            
            <!-- Status -->
            <td class="td">
              <status-selector
                :status="project.status"
                :project-id="project.id"
                @status-changed="changeStatut"
              />
            </td>
          </tr>
        </tbody>
        
        <!-- No Data or Loading States -->
        <noDataTable
          class="ma-4"
          v-else-if="projects.length === 0 && !loadingTable"
        />
        <progressCircular class="ma-8" v-else-if="loadingTable" />
      </table>
      
      <!-- Pagination -->
      <div class="d-flex">
        <v-col class="pa-0 pb-md-2">
          <pagination
            v-if="projects.length > 0"
            :pagination="pagination"
            @selectNumberOfRecords="filterResult"
            @first="filterResult({ type: 'next', numberOfPage: pagination.firstPage })"
            @last="filterResult({ type: 'next', numberOfPage: pagination.lastPage })"
            @prev="filterResult({ type: 'next', numberOfPage: pagination.prevPageUrl })"
            @current="filterResult({ type: 'next', numberOfPage: pagination.currentPage })"
            @next="filterResult({ type: 'next', numberOfPage: pagination.nextPageUrl })"
          />
        </v-col>
      </div>
    </v-card>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import EditableField from './components/EditableField.vue';
import StatusSelector from './components/StatusSelector.vue';
import FilterDropdown from './components/FilterDropdown.vue';
import ExcelExportDialog from './components/ExcelExportDialog.vue';
import noDataTable from "../../components/no-data-table.vue";
import progressCircular from "../../components/progress-circular.vue";
import Pagination from "../../components/dataTable/Pagination.vue";
import Loading from "@/components/ui/loading-component.vue";

export default {
  name: "RapportDeVenteNew",
  components: {
    EditableField,
    StatusSelector,
    FilterDropdown,
    ExcelExportDialog,
    pagination: Pagination,
    noDataTable,
    progressCircular,
    Loading,
  },
  data() {
    let sortOrders = {};
    let columns = [
      { label: "Date", name: "date", sortable: true, filter: true },
      { label: "Vendeur", name: "nom", sortable: true, filter: true },
      { label: "Raison Sociale", name: "raison", sortable: true, filter: true },
      { label: "Fournisseur", name: "fournisseur", sortable: true, filter: true },
      { label: "Energie", name: "type", sortable: true, filter: false },
      { label: "PDL", name: "numCompteur", sortable: true, filter: false },
      { label: "Consommation", name: "Consommation", sortable: true, filter: false },
      { label: "DDF", name: "dateDF", sortable: false, filter: true },
      { label: "DFF", name: "dateFF", sortable: false, filter: false },
      { label: "marge", name: "marge", sortable: true, filter: false },
      { label: "Valeur Brut", name: "valeurBrut", sortable: true, filter: false },
      { label: "Pourcentage", name: "Pourcentage", sortable: true, filter: false },
      { label: "Valeur AA", name: "valeurAA", sortable: true, filter: false },
      { label: "Valeur We Energy", name: "valeurGEMC", sortable: true, filter: false },
      { label: "Statut", name: "status", sortable: true, filter: true },
    ];
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });
    
    return {
      // UI control properties
      activeFilter: '',
      calculationMode: 'non',
      loadingTable: false,
      loadingDialogGlobal: false,
      loadingGlobalValue: false,
      messageGlobal: "",
      errorGlobalValue: false,
      dialogSheetFilter: false,
      
      // Data properties
      search: "",
      projects: [],
      dateFormulaire: [],
      columns,
      sortKey: "date",
      sortOrders,
      
      // Filter and items properties
      filterItem: {
        date: [],
        nom: [],
        raison: [],
        fournisseur: [],
        type: [],
        numCompteur: [],
        Consommation: [],
        Duree: [],
        marge: [],
        valeurBrut: [],
        Pourcentage: [],
        valeurAA: [],
        valeurGEMC: [],
        status: [],
        dateDebutFMIN: null,
        dateDebutFMAX: null,
      },
      items: {
        date: [],
        nom: [],
        raison: [],
        fournisseur: [],
        type: [],
        numCompteur: [],
        Consommation: [],
        Duree: [],
        marge: [],
        valeurBrut: [],
        Pourcentage: [],
        valeurAA: [],
        valeurGEMC: [],
        status: [],
        dateDebutFMIN: null,
        dateDebutFMAX: null,
      },
      
      // Request and pagination
      tableData: {
        draw: 0,
        length: 15,
        search: "",
        column: 0,
        dir: "desc",
        filterItems: null,
        filterType: "all",
      },
      pagination: {
        perPage: ["10", "15", "30", "all"],
        firstPage: 0,
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
      },
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loadingTable = true;
      try {
        await this.verifyUser();
        await this.getData();
        await this.getAllDate();
      } catch (error) {
        console.error('Error loading data:', error);
      } finally {
        this.loadingTable = false;
      }
    },
    
    async verifyUser() {
      var whoIam = "";
      await this.whoIAm(this.getToken("token")).then((data) => {
        whoIam = data;
      });
      if (whoIam == "noToken") {
        this.handleLogout();
      } else {
        localStorage.setItem("typeUser", whoIam);
      }
    },
    handleLogout() {
      localStorage.removeItem("vendeurName");
      localStorage.removeItem("typeUser");
      localStorage.removeItem("token");
      this.$router.push("/login");
    },
    
    handleExcelError(message) {
      this.loadingDialogGlobal = false;
      this.loadingGlobalValue = false;
      this.errorGlobalValue = true;
      this.messageGlobal = message;
    },
    
    formatNumber(value) {
      return isNaN(value) ? value : Number(value).toLocaleString("fr-FR");
    },
    
    formatDateForInput(dateString) {
      if (!dateString) return '';
      // Convert from "DD/MM/YYYY" to "YYYY-MM-DD" format for input[type="date"]
      const parts = dateString.split('/');
      if (parts.length !== 3) return dateString;
      return `${parts[2]}-${parts[1]}-${parts[0]}`;
    },
    
    getColumnClass(columnName) {
      if (this.sortKey === columnName) {
        return this.sortOrders[columnName] > 0 ? 'sorting_asc' : 'sorting_desc';
      }
      return 'sorting';
    },
    
    handleFilterUpdate({ field, values }) {
      this.filterItem[field] = values;
      this.filterResult({ type: 'filter', items: this.filterItem });
    },
    
    handleDateFilter({ min, max }) {
      this.filterItem.dateDebutFMIN = min;
      this.filterItem.dateDebutFMAX = max;
      this.filterResult({ type: 'filter', items: this.filterItem });
    },
    
    async getAllDate() {
      try {
        const response = await axios({
          url: process.env.VUE_APP_URL_API_CLIENT + "getAllDate/",
          method: "POST",
        });
        this.dateFormulaire = response.data.date;
      } catch (error) {
        console.error("Error fetching dates:", error);
      }
    },
    
    resetFilter() {
      this.search = "";
      this.filterItem = { ...this.items };
      this.filterItem.dateDebutFMIN = null;
      this.filterItem.dateDebutFMAX = null;
      this.filterResult({ type: "filter", items: this.filterItem, numberOfPage: 0 });
    },
    
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableData.column = this.getColumnIndex(key);
      this.tableData.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      this.filterResult({ type: "sort" });
    },
    
    getColumnIndex(columnName) {
      return this.columns.findIndex(column => column.name === columnName);
    },
    
    async modifierValue({ fieldType, projectId, value, calculationMode }) {
      // Create form data
      const formData = new FormData();
      formData.append("token", this.getToken("token"));
      formData.append("val", value);
      formData.append("RelierAuCalcule", calculationMode || this.calculationMode);
      formData.append("idVente", projectId);
      
      // Determine API endpoint based on field type
      let endpoint;
      switch(fieldType) {
        case 'date':
          // Format date for backend
          value = this.formatDateSlash(value);
          formData.set("val", value);
          endpoint = "updateDateVentePro";
          break;
        case 'consommation':
          endpoint = "updateConsommationVentePro";
          break;
        case 'valuemarge':
          endpoint = "updateMargeVentePro";
          break;
        case 'valeurBrut':
          endpoint = "updateValeurBrut";
          break;
        case 'pourcentage':
          endpoint = "updatePourcentageVentePro";
          break;
        case 'value':
          endpoint = "updateValueAAVentePro";
          break;
        case 'valueGEMC':
          endpoint = "updateAutreValueVentePro";
          break;
        default:
          console.error('Unknown field type:', fieldType);
          return;
      }
      
      try {
        const response = await axios({
          url: process.env.VUE_APP_URL_API_CLIENT + endpoint + "/",
          method: "POST",
          data: formData,
        });
        
        if (response.data.result === true) {
          alert("la valeur de cette vente a été mise à jour");
          await this.filterResult({ numberOfPage: this.pagination.currentPage });
        } else if (response.data.result === false) {
          alert("vérifiez que votre valeur soit valide");
          await this.filterResult({ numberOfPage: this.pagination.currentPage });
        } else if (response.data.result === "permission") {
          alert("permission refusée");
          this.handleLogout();
        }
      } catch (error) {
        console.error('Error updating value:', error);
        alert("Une erreur est survenue");
      }
    },
    
    formatDateSlash(dateString) {
      if (!dateString) return '';
      // Convert YYYY-MM-DD to DD/MM/YYYY
      const parts = dateString.split('-');
      if (parts.length !== 3) return dateString;
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
    },
    
    async changeStatut({ projectId, newStatus }) {
      const formData = new FormData();
      formData.append("newStatus", newStatus);
      formData.append("id", projectId);
      formData.append("token", this.getToken("token"));
      
      try {
        const response = await axios({
          url: process.env.VUE_APP_URL_API_CLIENT + "changeStatut/",
          method: "POST",
          data: formData,
        });
        
        if (response.data.result === true) {
          await this.getData(this.pagination.currentPage);
        } else {
          alert("permission refusée");
          this.handleLogout();
        }
      } catch (error) {
        console.error('Error changing status:', error);
        alert("Une erreur est survenue");
      }
    },
    
    async filterResult({ type, key = "", items = null, numberOfPage = 0 }) {
      // Set filter type
      if (["search", "nbrRecords", "filter", "sort", "next"].includes(type)) {
        this.tableData.filterType = type;
      }
      
      // Set parameters based on filter type
      let pageNumber = 0;
      
      if (type === "search") {
        pageNumber = 0;
        this.tableData.search = key;
      } else if (type === "nbrRecords") {
        this.tableData.search = this.search;
        this.tableData.length = key;
      } else if (type === "filter") {
        this.tableData.search = this.search;
        this.tableData.filterItems = items || this.filterItem;
        if (this.tableData.filterItems) {
          this.tableData.filterItems.dateDebutFMIN = this.filterItem.dateDebutFMIN;
          this.tableData.filterItems.dateDebutFMAX = this.filterItem.dateDebutFMAX;
        }
      } else if (type === "sort") {
        this.tableData.search = this.search;
      } else if (type === "next") {
        this.tableData.search = this.search;
        pageNumber = numberOfPage;
      } else {
        this.tableData.search = this.search;
        pageNumber = numberOfPage;
      }
      
      // Increment draw counter for request identification
      this.tableData.draw++;
      
      try {
        const response = await axios({
          url: process.env.VUE_APP_URL_API_CLIENT + "filterRapportVentePro/",
          method: "POST",
          data: {
            dataTable: this.tableData,
            pageNumber: pageNumber,
            type: this.tableData.filterType,
            itemsFilter: this.tableData.filterItems,
            token: this.getToken("token"),
          },
        });
        
        if (response.data.result === true) {
          const data = response.data.data;
          if (this.tableData.draw === data.draw) {
            this.projects = data.data.data;
            this.configPagination(data.data);
          }
        } else {
          alert("permission refusée");
          this.handleLogout();
        }
      } catch (error) {
        console.error("Error filtering results:", error);
      }
    },
    
    async getData(pageNumber = 0) {
      this.tableData.draw++;
      try {
        const response = await axios({
          url: process.env.VUE_APP_URL_API_CLIENT + "getVenteProServerSideRapportDeVente/",
          method: "POST",
          data: {
            dataTable: this.tableData,
            pageNumber: pageNumber,
            searchItem: "None",
            token: this.getToken("token"),
          },
        });
        
        if (response.data.result === true) {
          const data = response.data.data;
          
          // Update filter items
          this.items.nom = response.data.nom;
          this.items.raison = response.data.raison;
          this.items.fournisseur = response.data.fournisseur;
          this.items.type = response.data.type;
          this.items.status = response.data.listevaleurstatus;
          
          // Initialize filter with all items
          this.filterItem = { ...this.items };
          
          // Update projects data
          if (this.tableData.draw === data.draw) {
            this.projects = data.data.data;
            this.configPagination(data.data);
          }
        } else {
          alert("permission refusée");
          this.handleLogout();
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    
    configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
};
</script>

<style scoped>
.td-table,
.d1 {
  display: flex;
  justify-content: center;
}

.td {
  vertical-align: middle;
}

@media only screen and (max-width: 350px) {
  .search-input {
    width: 125px !important;
  }
}
</style>